import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { fDate } from "../../../../utils/formatTime";
import { useNavigate } from "react-router-dom";
import StyledTableContainer from "../../../newComponent/TableContainer";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { min } from "date-fns";
import VeiwIcon from "../../../newComponent/iconsComp/VeiwIcon";
import CustomPopup from "./../../../../components/CustomPopup";
import TransferStudentForm from "./studentDetails/EnrolledStudents/transferStudent/TransferStudentForm";
import { Edit } from "@mui/icons-material";
import EditIconcomp from "./../../../newComponent/iconsComp/EditIconcomp";
import TransferIcon from "../../../newComponent/iconsComp/TransferIcon";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function StudentTable({
  students,
  setStudent,
  studentsForCurrentPage,
  isLoading,
  page,
  rowsPerPage,
}) {
  const userId = localStorage.getItem("userId");
  const [openTransferDialog, setOpenTransferDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const navigate = useNavigate();
  const handleViewMoreClick = (studentId, studentDetail) => {
    navigate(`/view-student/${studentId}`, { state: { studentDetail } });
  };

  const handleViewMore = (studentId, studentDetail) => {
    const url = `/view-student/${studentId}`;
    const newState = { studentDetail };

    // Open link in new tab
    const newTab = window.open(url, "_blank");

    // If new tab opened successfully, navigate with state data
    if (newTab) {
      newTab.onload = () => {
        newTab.history.replaceState(newState, "", url);
      };
    } else {
      // If new tab was blocked by browser, navigate with state data in current tab
      navigate(url, { state: newState });
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      //width: 100,
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <VeiwIcon
            onClick={() => handleViewMore(params.row.id, params.row)}
            fontSize="1rem"
            tooltipTitle="View More"
          />
          {/* <TransferIcon color="#00b13f" fontSize="1rem" tooltipTitle="Transfer" onClick={()=>handleOpenTransferDialog(params.row)}/> */}
        </div>
      ),
    },
    {
      field: "studentName",
      headerName: "Student Name",
      //width: 100,
      flex: 1,
      minWidth: 200,
      renderCell: (params) =>
        `${params.row.enquiry_id?.first_name || ""} ${params.row.enquiry_id?.last_name || ""}`,
    },
    {
      field: "enrollmentNo",
      headerName: "Enrollment No",
      //width: 100,
      flex: 1,
      minWidth: 100,
      renderCell: (params) => params.row.lead_no,
    },
    {
      field: "enrollmentDate",
      headerName: "Enrollment Date",
      //width: 100,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => fDate(params.row.joining_date),
    },
    {
      field: "branch",
      headerName: "Branch",
      //width: 100,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => params.row.branch_id?.branch_name,
    },
    {
      field: "testType",
      headerName: "Test Type",
      //width: 100,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => params.row.enquiry_id?.test_type_id?.name,
    },

    {
      field: "status",
      headerName: "Status",
      //width: 100,
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <Chip
          label={params.row.status_of_student}
          size="small"
          variant="contained"
          color={
            params.row.status_of_student === "active" ? "secondary" : "error"
          }
        />
      ),
    },
  ];

  const rows =
    students?.map((item, index) => ({
      id: item.id || index,
      ...item,
    })) || [];

  const handleOpenTransferDialog = (rowData) => {
    setOpenTransferDialog(true);
    setSelectedRowData(rowData);
  };

  const handleCloseTransferDialog = () => {
    setOpenTransferDialog(false);
  };

  return (
    <>
      <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Stack direction="row" spacing={1}>
          <Typography
            variant="h4"
            color="secondary"
            fontWeight={800}
            marginRight={2}
          >
            Fetching
          </Typography>
          <CircularProgress color="primary" />
        </Stack>
      </Backdrop>

      <Box>
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          pageSizeOptions={[25, 50, 100]}
        />
      </Box>

      <CustomPopup
        open={openTransferDialog}
        onClose={handleCloseTransferDialog}
        title="Transfer Student"
        maxWidth="sm"
        showDivider={true}
        component={
          <TransferStudentForm
            onClose={handleCloseTransferDialog}
            selectedRowData={selectedRowData}
          />
        }
      />
    </>
  );
}
